import { translate } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import _ from 'lodash';
var Experience;
(function (Experience) {
    Experience["V1"] = "v1";
    Experience["V2"] = "v2";
})(Experience || (Experience = {}));
var EarlyAccessPropValues;
(function (EarlyAccessPropValues) {
    EarlyAccessPropValues["ENABLED_FOR_CLUSTER"] = "enabled-for-cluster";
    EarlyAccessPropValues["DISABLED"] = "disabled";
    EarlyAccessPropValues["ENABLED"] = "enabled";
})(EarlyAccessPropValues || (EarlyAccessPropValues = {}));
const EARLY_ACCESS_SETTING_ID = 'early_access_feature';
const DM_SETTING_ID = 'dataModelling';
const getExperience = (value) => {
    return `${value}` === 'true' ? Experience.V2 : Experience.V1;
};
const getConfigState = (value) => {
    return `${value}` === 'true'
        ? EarlyAccessPropValues.ENABLED_FOR_CLUSTER
        : EarlyAccessPropValues.DISABLED;
};
const getDMConfigState = (value) => {
    const isEnabled = typeof value === 'boolean' ? value : value === 'true';
    return isEnabled
        ? EarlyAccessPropValues.ENABLED
        : EarlyAccessPropValues.DISABLED;
};
const getConfigId = (value) => {
    const values = _.split(value, '.');
    if (values.length > 1) {
        values.shift();
    }
    return values.join('.');
};
const getEarlyAccessSettingId = () => {
    return EARLY_ACCESS_SETTING_ID;
};
const experienceMetricProperties = {
    'orion.answerV2Experience': (oldValue, newValue) => ({
        clusterSwitchAnswerVersionFrom: getExperience(oldValue),
        clusterSwitchAnswerVersionTo: getExperience(newValue),
    }),
    'orion.a3Config.spotIQV2Experience': (oldValue, newValue) => ({
        clusterSwitchSpotIQVersionFrom: getExperience(oldValue),
        clusterSwitchSpotIQVersionTo: getExperience(newValue),
    }),
    'orion.pinboardV2Experience': (oldValue, newValue) => ({
        clusterSwitchPinboardVersionFrom: getExperience(oldValue),
        clusterSwitchPinboardVersionTo: getExperience(newValue),
    }),
    'orion.isAnswerV2OnByDefault': (oldValue, newValue) => ({
        clusterDefaultAnswerVersionFrom: getExperience(oldValue),
        clusterDefaultAnswerVersionTo: getExperience(newValue),
    }),
    'orion.a3Config.isSpotIQV2OnByDefault': (oldValue, newValue) => ({
        clusterDefaultSpotIQVersionFrom: getExperience(oldValue),
        clusterDefaultSpotIQVersionTo: getExperience(newValue),
    }),
    'orion.isPinboardV2OnByDefault': (oldValue, newValue) => ({
        clusterDefaultPinboardVersionFrom: getExperience(oldValue),
        clusterDefaultPinboardVersionTo: getExperience(newValue),
    }),
    'orion.aiAnswerGenerationEnabled': (oldValue, newValue) => ({
        clusterSwitchAiAnswerGenerationFrom: getExperience(oldValue),
        clusterSwitchAiAnswerGenerationTo: getExperience(newValue),
    }),
    aiAnswerGenerationEnabled: (oldValue, newValue) => ({
        clusterSwitchAiInfraAnswerGenerationFrom: getExperience(oldValue),
        clusterSwitchAiInfraAnswerGenerationTo: getExperience(newValue),
    }),
    'orion.generateSpotiqInsightsUsingLlm': (oldValue, newValue) => ({
        clusterSwitchAnalysisDescriptionGenerationFrom: getExperience(oldValue),
        clusterSwitchAnalysisDescriptionGenerationTo: getExperience(newValue),
    }),
    'orion.enableSeedQuestions': (oldValue, newValue) => ({
        clusterSwitchSeedQuestionGenerationFrom: getExperience(oldValue),
        clusterSwitchSeedQuestionGenerationTo: getExperience(newValue),
    }),
};
const getDisclaimerTextLength = (value) => {
    return value.trim().length;
};
const disclaimerTextMetricProperty = {
    'orion.exportConfig.legalDisclaimerText': (value) => ({
        disclaimerTextLength: getDisclaimerTextLength(value),
    }),
};
const collectEarlyAccessFeatureEvents = (settingId, configs, configsMap, metricsService, isReset = false) => {
    if (settingId !== getEarlyAccessSettingId())
        return;
    const earlyAccessFeatureMetricProperty = [];
    let isConfigModified;
    if (!isReset) {
        configs.forEach(config => {
            if (configsMap.has(config.id) &&
                `${configsMap.get(config.id).value}` !== `${config.value}`) {
                isConfigModified = true;
                earlyAccessFeatureMetricProperty.push({
                    propertyName: getConfigId(config.id),
                    newValue: getConfigState(config.value),
                    oldValue: getConfigState(configsMap.get(config.id).value),
                    operationType: 'update',
                });
            }
        });
    }
    else {
        isConfigModified = true;
        earlyAccessFeatureMetricProperty.push({ operationType: 'reset' });
    }
    if (isConfigModified) {
        const actionType = isReset
            ? userActionTypeEnum.EARLY_ACCESS_FEATURE_RESET
            : userActionTypeEnum.EARLY_ACCESS_FEATURE_UPDATE;
        metricsService.collectEvent(new UserAction(actionType), {
            updatedEarlyAccessFeatures: earlyAccessFeatureMetricProperty,
            isResetOperation: isReset,
        });
    }
};
const collectDMFeatureEvents = (settingId, configs, configsMap, metricsService) => {
    if (settingId !== DM_SETTING_ID)
        return;
    let dmFeatureMetricProperty = {};
    let isConfigModified;
    configs.forEach((config) => {
        const previousStatus = configsMap.has(config.id)
            ? getDMConfigState(configsMap.get(config.id).value)
            : undefined;
        if (configsMap.has(config.id) &&
            `${configsMap.get(config.id).value}` !== `${config.value}`) {
            isConfigModified = true;
        }
        dmFeatureMetricProperty = {
            dmFlagName: translate(`${getConfigId(config.id)}.title`),
            dmFlagCommand: getConfigId(config.id),
            dmFlagStatus: getDMConfigState(config.value),
            dmFlagPreviousStatus: previousStatus,
        };
    });
    if (isConfigModified) {
        metricsService.collectEvent(new UserAction(userActionTypeEnum.DATA_MODELLING_FEATURE_FLAG), dmFeatureMetricProperty);
    }
};
export default {
    experienceMetricProperties,
    disclaimerTextMetricProperty,
    collectEarlyAccessFeatureEvents,
    EARLY_ACCESS_SETTING_ID,
    collectDMFeatureEvents,
    DM_SETTING_ID,
};
//# sourceMappingURL=editscreen-metrics-util.js.map